<template>
  <v-dialog
    :value="opened"
    :fullscreen="$vuetify.breakpoint.xsOnly"
    v-if="currentUser && !currentUser.is_advisor"
    width="600"
    persistent
  >
    <v-card class="content-container">
      <v-card-text>
        <v-flex column xs12>
          <v-alert
            :value="true"
            class="mb-4 text-xs-left"
            type="info"
            outline
            v-if="customWelcomeMessage"
          >
            {{ customWelcomeMessage }}
          </v-alert>

          <v-divider class="my-2" v-if="customWelcomeMessage" />

          <v-layout class="mb-3 text-xs-left" column>
            <div class="dialog-title">
              <h4>Don't want to miss any notifications?</h4>
            </div>

            <div class="mt-2">
              <p style="font-size: 16px">Let us remind you via SMS.</p>

              <v-flex xs12>
                <div class="" style="font-size: 15px">Your phone number</div>

                <v-text-field
                  name="phone-number"
                  type="phone"
                  mask="phone"
                  placeholder="(123) 456 - 7890"
                  v-model="currentUser.phone_number"
                  solo
                  class="default-input mt-1"
                />

                <span>* Msg & data rates may apply.</span>
              </v-flex>
            </div>
          </v-layout>
          <v-alert class="text-xs-left" outline :value="true" type="info">
            By providing this phone number, you agree to receive messages from
            {{ currentFirm.name }}. Message and data rates may apply. Message
            frequency varies.
          </v-alert>

          <v-layout>
            <v-spacer class="hidden-xs-only" />
            <v-btn
              class="default-input text-none primary"
              @click="saveContactInfo()"
              :disabled="!currentUser.phone_number"
            >
              Submit
            </v-btn>
            <v-btn
              class="default-input text-none primary primary--text"
              outline
              @click="skip()"
            >
              Skip
            </v-btn>
          </v-layout>
        </v-flex>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import API from '@/api';
import { mapGetters } from 'vuex';
import get from 'lodash/get';

export default {
  name: 'ContactMethodDialog',

  props: {
    questionnaire: {
      type: Object,
      default: null,
    },

    opened: {
      type: Boolean,
    },
  },

  data() {
    return {
      preferredContactMethods: [
        {
          label: 'Email & Text',
          value: 'sms',
        },
        {
          label: 'Email',
          value: 'email',
        },
      ],
    };
  },

  methods: {
    async saveContactInfo() {
      try {
        this.$emit('update:opened', false);

        const response = await API.user.updateUser({
          id: this.currentUser.id,
          preferred_contact_method: 'sms',
          phone_number: this.currentUser.phone_number,
        });

        if (response.data.error) {
          console.log(response.data.error);
          this.$store.dispatch('application/setErrorNotification', {
            message: 'Something went wrong while saving progress.',
            errorToSend: response.data.error,
            userEmail: this.currentUser.email,
          });
        } else {
          this.$store.dispatch('getCurrentUser');
          this.$store.dispatch('application/setSuccessNotification', {
            message: 'Successfully Updated!',
          });
        }
      } catch (e) {
        console.log(e);
        this.$store.dispatch('application/setErrorNotification', {
          message: 'Something went wrong while saving progress.',
          errorToSend: e,
          userEmail: this.currentUser.email,
        });
      }
    },

    async skip() {
      this.$emit('update:opened', false);

      await API.user.updateUser({
        id: this.currentUser.id,
        preferred_contact_method: 'email',
      });
    },
  },

  computed: {
    ...mapGetters({
      currentUser: 'user',
      currentFirm: 'currentFirm',
    }),

    customWelcomeMessage() {
      let customMessage = null;

      if (get(this.currentFirm, 'preferences.custom_welcome_message', false)) {
        customMessage = this.currentFirm.preferences.custom_welcome_message;
        customMessage = customMessage.replaceAll(
          '{client_fname}',
          this.currentUser.fname,
        );
        customMessage = customMessage.replaceAll(
          '{client_lname}',
          this.currentUser.lname,
        );
        customMessage = customMessage.replaceAll(
          '{client_preferred_name}',
          this.currentUser.salutation_fname,
        );
        customMessage = customMessage.replaceAll(
          '{client_full_name}',
          this.currentUser.full_name,
        );
      }

      return customMessage;
    },
  },
};
</script>

<style lang="postcss" scoped>
.dialog-title {
  padding: 10px 0px;

  & >>> h4 {
    font-size: 21px;
    font-weight: bold;
    font-family: var(--font-family-sans);
  }
}
</style>
